<h1 uid="error__title">{{ 'msg-error-title' | translate }}</h1>
@if (api().error) {
  <div>{{ api().error }}</div>
} @else {
  {{ 'msg-error-txt' | translate }}
}
